module.exports = __webpack_public_path__ + "static/media/retail.5be2ab9c.svg";